<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" :dark="true" :page-index="filterData.pageIndex" :page-size="filterData.pageSize" :total="total" @changePage="changePage">
                <!-- <div class="course-title">
                    <span :class="[{'active': curTab === item.id}]" v-for="item in tagList" :key="item.id" @click="switchTag(item.id)">{{item.name}}</span>
                </div> -->
            </CommonTitle>
            <ul class="course-list" v-if="list.length" v-loading="loading">
                <li class="course-list-item" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
                    <div v-link="linkUrl(item.id)" class="course-list-item-link">
                        <div class="list-item-img">
                            <span class="tag" v-if="item.courseCreditTypeName">{{ item.courseCreditTypeName?.slice(0,6) || '' }}</span>
                            <LazyImage :src="item.previewUrl" className="img" />
                        </div>
                        <div class="list-item-content">
                            <div class="title flex-start">
                                <span class="name text-overflow" :title="item.courseName">{{ item.courseName }}</span>
                            </div>
                            <div class="publish-info">
                                <div class="publish-name text-overflow" :title="`发布人：${item.publishUserName}`">{{item.publishUserName}}</div>
                                <div class="publish-label">发布</div>
                                <div class="seperator"></div>
                                <div class="publish-stage text-overflow" :title="`学段学科：${item.stageSubjectName}`">{{item.stageSubjectName}}</div>
                            </div>
                            <div class="flex-between course-operate">
                                <div class="course-score">{{item.courseCredit || 0}}学分/{{item.coursePeriod || 0}}学时</div>
                                <div class="sign">报名</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-data" url="no-course@2x.png" info="暂无研修课程" />
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/common-index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { pageJump } from '@/global/location-transfer'
import { handleStageSubject } from '@/lib/tools';

import { useStore } from 'vuex'
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router'

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
})
const router = useRouter()
const total = ref(0)
const list = ref([]);
const store = useStore();

const tagList = ref([
    {
        id: 'time',
        name: '最新'
    },
    {
        id: 'hot',
        name: '最热'
    }
])

const curTab = ref('hot');

const loading = ref(false);

const filterData = reactive({
    courseType: 1,
    pageIndex: 1,
    pageSize: 4,
    orderBy: 'desc'
});

const obj = {
    type: 'network'
}

function getList () {
    loading.value = true;
    G_transmit('courseSquareList', {
        name: 'courseSquareList',
        queries: {
            ...filterData,
            sortBy: curTab.value,
        }
    }).then((res) => {
        console.log('course', res)
        let arr = res.data?.rows || [];
        total.value = res.data?.total || 0
        list.value = arr.length && arr.map(item => {
            item.stageSubjectName = handleStageSubject(item.subjectStageGrade, '暂无');
            return item;
        }) || [];
    }).finally(() => {
        loading.value = false;
    });
}

const changePage = (pageIndex) => {
    console.log('pageIndex1', pageIndex)
    filterData.pageIndex = pageIndex
    getList();
}
// 切换
function switchTag(tag = 'time') {
    curTab.value = tag;
    filterData.pageIndex = 1
    getList();
}


function goMore(){
    pageJump({name: 'courseSquare'});
}

function goDetail(id) {
    pageJump({
        name: 'courseDetails',
        query: {
            courseId: id
        }
    }, true);
}

function linkUrl(id){
    const url = router.resolve({name: 'courseDetails'}).path;
    return {
        url: `${url}?courseId=${id}`,
        className: 'link-item'
    }
}


onMounted(() => {
    switchTag('time');
})

</script>

<style lang="scss" scoped>
.common-module-page {
    // width: 100vw;
    background: #F8F8F8;
    padding-bottom: 30px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.course-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}

.course-list-item {
    box-sizing: border-box;
    width: 585px;
    height: 146px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-left: 30px;
    margin-top: 20px;
    display: flex;
    cursor: pointer;
    &:nth-child(1), &:nth-child(2) {
        margin-top: 0;
    }
    &:nth-child(2n+1) {
        margin-left: 0;
    }

    &:hover {
        box-shadow: 0px 4px 12px 0px rgba(37,54,82,0.08);
    }

    .list-item-img {
        width: 110px;
        height: 146px;
        border-radius: 4px;
        position: relative;
        .tag {
            background: rgba(34, 34, 34, .8);
            border-radius: 0px 4px 0px 4px;
            font-size: 14px;
            line-height: 14px;
            color: var(--srt-color-white);
            position: absolute;
            bottom: 0px;
            left: 0px;
            z-index: 100;
            padding: 3px 6px;
        }

        .img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
        }
    }

    .list-item-content {
        width: 0;
        flex: 1;
        padding: 20px;
        position: relative;
        .title {
            margin-bottom: 12px;
            white-space: nowrap;
        }
        .name {
            font-weight: bold;
            color: var(--srt-main-text-color);
            font-size: 16px;
            line-height: 21px;
        }
        .publish-info {
            font-size: 14px;
            color: #222222;
            line-height: 19px;
            display: flex;
            align-items: center;
            .publish-name {
                max-width: 124px;
            }
            .publish-label {
                color: #666666;
                margin-left: 8px;
            }
            .seperator {
                width: 1px;
                height: 12px;
                background: #666666;
                margin-left: 16px;
                margin-right: 16px;
            }
            .publish-stage {
                width: 0;
                flex: 1;
            }
        }
        .course-operate {
            margin-top: 26px;
            .course-score {
                display: inline-block;
                height: 24px;
                background: #FFF6EA;
                border-radius: 2px;
                padding: 3px 8px;
                font-size: 14px;
                color: #E59120;
                line-height: 19px;
            }
            .sign {
                width: 56px;
                height: 28px;
                background: linear-gradient(307deg, #5675FF 0%, #2E9EFF 100%);
                border-radius: 6px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
                color: #FFFFFF;
                line-height: 28px;
            }
        }
    }
}
:deep(.link-item){
    width:100%;
    .course-list-item-link{
        display: flex;
    }
}
.course-title {
    flex: 1;
    padding: 0px 30px;
    margin-bottom: 15px;
    color: var(--srt-color-gray);
    cursor: pointer;
    span {
        margin-right: 20px;
        &.active {
            color: var(--home-main-color);
        }
    }
}

.no-data {
    margin-top: 50px;
}
</style>